import React from 'react';
import { formatUSD, KTT_EMAIL, KTT_CODE, COMPANY } from '../utils/keyGenerator';
import TxTable from '../components/TxTable';

export default function Dashboard({ wallet, transactions, totalCredit, totalDebit, setPage, accounts }) {

  return (
    <div className="gap-16">
      {/* Settlement Status */}
      <div className="settle-bar">
        <div className="settle-dot" />
        <span className="settle-text">REAL-TIME SETTLEMENT ACTIVE</span>
        <span className="settle-time">
          {new Date().toLocaleString("en-GB", { dateStyle: "medium", timeStyle: "medium" })}
        </span>
      </div>

      {/* Stats */}
      <div className="grid4">
        {[
          { label: "Wallet Balance", value: formatUSD(wallet.balance), sub: "USD Available", cls: "stat-green", tile: "teal" },
          { label: "Total Credited", value: formatUSD(totalCredit), sub: `${transactions.filter(t => t.creditAmount).length} deposits`, cls: "", tile: "gold" },
          { label: "Total Debited", value: formatUSD(totalDebit), sub: `${transactions.filter(t => t.debitAmount).length} payments`, cls: "stat-red", tile: "coral" },
          { label: "Transactions", value: transactions.length, sub: "All time", cls: "", tile: "blue" },
        ].map((s, i) => (
          <div key={i} className={`stat-tile ${s.tile}`}>
            <div className="stat-label">{s.label}</div>
            <div className={`stat-value ${s.cls}`}>{s.value}</div>
            <div className="stat-sub">{s.sub}</div>
          </div>
        ))}
      </div>

      {/* Accounts Overview */}
      {accounts && accounts.length > 0 && (
        <div className="card">
          <div className="card-header">
            <span className="card-title">Accounts ({accounts.length})</span>
            <button className="btn btn-outline btn-sm" onClick={() => setPage("accounts")}>Manage Accounts</button>
          </div>
          <div className="card-body" style={{ padding: 0 }}>
            <table>
              <thead>
                <tr>
                  <th>IBAN</th>
                  <th>Holder</th>
                  <th>Type</th>
                  <th>Currency</th>
                  <th style={{ textAlign: 'right' }}>Balance</th>
                  <th style={{ textAlign: 'center' }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {accounts.map(acct => (
                  <tr key={acct.iban} style={{ cursor: 'pointer' }} onClick={() => setPage("accounts")}>
                    <td style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 11, color: 'var(--gold)', fontWeight: 600, letterSpacing: 1 }}>
                      {acct.ibanFormatted}
                    </td>
                    <td style={{ fontWeight: 600 }}>{acct.holderName}</td>
                    <td><span className="badge badge-ktt" style={{ fontSize: 10 }}>{acct.type}</span></td>
                    <td>{acct.currency}</td>
                    <td style={{ textAlign: 'right', fontWeight: 700, color: acct.balance > 0 ? 'var(--teal)' : 'var(--text2)' }}>
                      {formatUSD(acct.balance)}
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      <span className="badge badge-settled" style={{ fontSize: 10 }}>{acct.status}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Recent Transactions */}
      <div className="card">
        <div className="card-header">
          <span className="card-title">Recent Transactions</span>
          <button className="btn btn-outline btn-sm" onClick={() => setPage("ledger")}>View All</button>
        </div>
        <TxTable rows={transactions.slice(0, 8)} />
      </div>

      {/* Bottom Grid */}
      <div className="grid2">
        {/* Quick Actions */}
        <div className="card">
          <div className="card-body">
            <div className="stat-label">Quick Actions</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: 16 }}>
              <button className="btn btn-gold" onClick={() => setPage("deposit")}>
                Deposit via Ledger JSON
              </button>
              <button className="btn btn-outline" onClick={() => setPage("ktt")}>
                Send via KTT
              </button>
              <button className="btn btn-outline" onClick={() => setPage("reports")}>
                Reports & Export
              </button>
            </div>
          </div>
        </div>

        {/* Wallet Info */}
        <div className="card">
          <div className="card-body">
            <div className="stat-label">Wallet Information</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 0, marginTop: 16 }}>
              {[
                ["Account Holder", COMPANY],
                ["Currency", "USD (Fiat)"],
                ["KTT Email", KTT_EMAIL],
                ["KTT Code", KTT_CODE],
                ["Settlement", "Real-Time"],
                ["ISO 20022", "pacs.008 / pacs.009 / camt.053"],
              ].map(([k, v]) => (
                <div key={k} style={{
                  display: "flex", justifyContent: "space-between",
                  fontSize: 13, padding: "10px 0",
                  borderBottom: "1px solid var(--border-light)"
                }}>
                  <span style={{ color: "var(--text2)" }}>{k}</span>
                  <span style={{ color: "var(--gold)", fontWeight: 600, fontFamily: "'IBM Plex Mono', monospace", fontSize: 12 }}>{v}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
